<script>
  import { checkbox } from 'vue-strap';
  import Radio from '~componentes/Radio.vue';

  export default {
    components: { checkbox, Radio },
    props: {
      solicitacao: Object,
      edicao: Boolean,
    },
    data() {
      return {
        configuracao: this.$storage.configuracao(),
      }
    },
    computed: {
      labelDuracao() {
        if (parseInt(this.solicitacao.tipoSolicitacao) == 1) {
          return 'Duração do curso';
        }
        if (parseInt(this.solicitacao.tipoSolicitacao) == 2) {
          return 'Dia e horário do evento';
        }
        return 'Duração';
      },
      labelMetodologia() {
        if (parseInt(this.solicitacao.tipoSolicitacao) == 2) {
          return 'Programação';
        }
        return 'Metodologia';
      }
    },
    methods: {
      preencherDadosContato() {
        let usuario = this.$storage.usuario();

        this.$set(this.solicitacao, 'nomeSolicitante', usuario.nome);
        this.$set(this.solicitacao, 'emailSolicitante', usuario.email);
        this.$set(this.solicitacao, 'telefoneSolicitante', usuario.telefone.substring(0, 20));
      },
      validarDadosSolicitacao() {
        return this.$validator.validateAll();
      },
    },
    mounted() {
    }
  }
</script>

<template>
  <div>
    <div class="row">
      <div class="col-xs-12">
        <div class="form-group">
          <label class="control-label" for="informacoes-solicitacao">
            Informações
          </label>

          <textarea class="form-control"
                    id="informacoes-solicitacao"
                    v-model="solicitacao.solicitacaoCursoEventos[0].informacoes">
          </textarea>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-xs-12">
        <div class="form-group">
          <label class="control-label" for="observacoes-solicitacao">
            Observações
          </label>

          <textarea class="form-control"
                    id="observacoes-solicitacao"
                    v-model="solicitacao.solicitacaoCursoEventos[0].observacoes">
          </textarea>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-xs-12">
        <div class="form-group">
          <label class="control-label" for="justificativa-solicitacao">
            Justificativa
          </label>

          <textarea class="form-control"
                    id="justificativa-solicitacao"
                    v-model="solicitacao.solicitacaoCursoEventos[0].justificativa">
          </textarea>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-xs-12">
        <div class="form-group">
          <label class="control-label" for="objetivos-solicitacao">
            Objetivos
          </label>

          <textarea class="form-control"
                    id="objetivos-solicitacao"
                    v-model="solicitacao.solicitacaoCursoEventos[0].objetivos">
          </textarea>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-xs-12">
        <div class="form-group">
          <label class="control-label" for="metodologia-solicitacao">
            {{ labelMetodologia }}
          </label>

          <textarea class="form-control"
                    id="metodologia-solicitacao"
                    v-model="solicitacao.solicitacaoCursoEventos[0].metodologia">
          </textarea>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-xs-12">
        <div class="form-group">
          <label class="control-label" for="infraestrutura-solicitacao">
            Infraestrutura
          </label>

          <textarea class="form-control"
                    id="infraestrutura-solicitacao"
                    v-model="solicitacao.solicitacaoCursoEventos[0].infraestrutura">
          </textarea>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-xs-12">
        <div class="form-group">
          <label class="control-label" for="ementaDisciplina-solicitacao">
            Ementa\Disciplinas
          </label>

          <textarea class="form-control"
                    id="ementaDisciplina-solicitacao"
                    v-model="solicitacao.solicitacaoCursoEventos[0].ementaDisciplina">
          </textarea>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-xs-12">
        <div class="form-group">
          <label class="control-label" for="preRequisito-solicitacao">
            Pré-requisito
          </label>

          <textarea class="form-control"
                    id="preRequisito-solicitacao"
                    v-model="solicitacao.solicitacaoCursoEventos[0].preRequisito">
          </textarea>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-xs-12">
        <div class="form-group">
          <label class="control-label" for="publicoAlvo-solicitacao">
            Público-alvo
          </label>

          <textarea class="form-control"
                    id="publicoAlvo-solicitacao"
                    v-model="solicitacao.solicitacaoCursoEventos[0].publicoAlvo">
          </textarea>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-xs-12">
        <div class="form-group">
          <label class="control-label" for="formaPagamento-solicitacao">
            Formas de pagamento
          </label>

          <textarea class="form-control"
                    id="formaPagamento-solicitacao"
                    v-model="solicitacao.solicitacaoCursoEventos[0].formaPagamento">
          </textarea>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-xs-12">
        <div class="form-group">
          <label class="control-label" for="devolucaoInscricao-solicitacao">
            Devolução de inscrição
          </label>

          <textarea class="form-control"
                    id="devolucaoInscricao-solicitacao"
                    v-model="solicitacao.solicitacaoCursoEventos[0].devolucaoInscricao">
          </textarea>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-xs-12">
        <div class="form-group">
          <label class="control-label" for="local-solicitacao">
            Local
          </label>

          <textarea class="form-control"
                    id="local-solicitacao"
                    v-model="solicitacao.solicitacaoCursoEventos[0].local">
          </textarea>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-xs-12">
        <div class="form-group">
          <label class="control-label" for="duracao-solicitacao">
            {{ labelDuracao }}
          </label>

          <textarea class="form-control"
                    id="duracao-solicitacao"
                    v-model="solicitacao.solicitacaoCursoEventos[0].duracao">
          </textarea>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-xs-12">
        <div class="form-group">
          <label class="control-label" for="areaConhecimento-solicitacao">
            Área do conhecimento
          </label>

          <textarea class="form-control"
                    id="areaConhecimento-solicitacao"
                    v-model="solicitacao.solicitacaoCursoEventos[0].areaConhecimento">
          </textarea>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-xs-12">
        <div class="form-group">
          <label class="control-label" for="outrasInformacoes-solicitacao">
            Outras informações
          </label>

          <textarea class="form-control"
                    id="outrasInformacoes-solicitacao"
                    v-model="solicitacao.solicitacaoCursoEventos[0].outrasInformacoes">
          </textarea>
        </div>
      </div>
    </div>

  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-curso-evento-servico/componentes/compartilhado/FormDadosAdicionais.vue